import { render, staticRenderFns } from "./MapboxAttribution.vue?vue&type=template&id=b9bf823a&scoped=true&"
import script from "./MapboxAttribution.vue?vue&type=script&lang=js&"
export * from "./MapboxAttribution.vue?vue&type=script&lang=js&"
import style0 from "./MapboxAttribution.vue?vue&type=style&index=0&id=b9bf823a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bf823a",
  null
  
)

export default component.exports